import { createEffect, createSignal, Show } from "solid-js";

import type { UtdoVideo } from "../types";
import { InputField } from "./InputField";
import { toNullableInt, toString } from "../util/converters";

type VideosEditorProps = {
    video: UtdoVideo;
    validate: (video: UtdoVideo) => any;
    cancel: () => any;
};

export function VideosEditor(props: VideosEditorProps) {
    const [ url, setUrl ] = createSignal<string>("");

    createEffect(() => setUrl(props.video.url));

    let idRef!: HTMLInputElement;
    let titleRef!: HTMLInputElement;
    let urlRef!: HTMLInputElement;
    let hiddenRef!: HTMLInputElement;

    const cancel = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        props.cancel();
    };

    const validate = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        const id = toNullableInt(idRef.value);
        const title = toString(titleRef.value);
        const url = toString(urlRef.value);
        const hidden = hiddenRef.checked;
        props.validate({
            id,
            title,
            url,
            sort: 0, // le sort est ignoré par les inserts/updates
            hidden,
        });
    };

    return <form onSubmit={validate} autocomplete="off">
        <input ref={idRef} type="hidden" value={props.video.id}/>
        <InputField
            ref={titleRef}
            type="text"
            id="video-titre"
            label="Titre"
            required
            value={props.video.title}/>
        <InputField
            ref={urlRef}
            type="text"
            id="video-url"
            label="Url"
            required
            value={props.video.url}
            onChange={() => setUrl(urlRef.value)}/>
        <InputField
            ref={hiddenRef}
            type="checkbox"
            id="video-cache"
            label="Cacher"
            required
            value={props.video.hidden}/>
        <div class="preview">
            <Show when={url().length > 0}>
                <iframe width="640" height="360" src={`https://www.youtube.com/embed/${url()}`} frameborder="0" title="{{.Title}}" allowfullscreen></iframe>
            </Show>
        </div>
        <div class="actions">
            <input type="submit" value="Enregistrer" class="accent" />
            <button onClick={cancel}>Annuler</button>
        </div>
    </form>;
}